import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={i < rating ? "star filled" : "star"}>
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="product-detail__images">
          <div className="product-detail__thumbnails">
            {product.images.map((img, idx) => (
              <div
                key={idx}
                className={`product-detail__thumbnail ${selectedImage === idx ? "active" : ""}`}
                onClick={() => setImage(idx)}
              >
                <img src={img} alt={`Thumbnail ${idx + 1}`} />
              </div>
            ))}
          </div>
          <div className="product-detail__main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
        </div>
        <div className="product-detail__info">
          <h1 className="product-detail__title">{product.name}</h1>
          <div className="product-detail__rating">
            {renderStars(product.rating)}
            <span className="review-count">({product.reviews} reviews)</span>
          </div>
          <p className="product-detail__price">${product.price}</p>
          <div className="product-detail__shipping">
            <span>🚚 Standard tracked shipping: $9.99 per order</span>
            <span>🔘 Size showing below is US size</span>
          </div>
          
          <div className="product-detail__size">
            <div className="product-detail__label">
              <span>SIZE</span> 
            </div>
            <div className="product-detail__size-options">
              {product.size.map((size) => (
                <button
                  key={size}
                  className={`size-option ${selectedSize === size ? "active" : ""}`}
                  onClick={() => setSelectedSize(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          <div className="product-detail__color">
            <div className="product-detail__label">COLOR</div>
            <div className="product-detail__color-options">
              {product.colors.map((color) => (
                <button
                  key={color}
                  className={`color-option ${selectedColor === color ? "active" : ""}`}
                  onClick={() => setSelectedColor(color)}
                >
                  {color}
                </button>
              ))}
            </div>
          </div>

          <div className="product-detail__quantity">
            <div className="product-detail__label">QUANTITY</div>
            <div className="quantity-selector">
              <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                −
              </button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>
          </div>

          <button className="product-detail__add-to-cart" onClick={handleAddToCart}>
            ADD TO CART
          </button>
        

         

          

          <div className="product-detail__description">
            {product.description.map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          <div className="product-detail__features">
            {product.Features.map((feature, idx) => (
              <p key={idx}>{feature}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
